import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { DocumentListFilterParams } from '~bank-documents/types/documentList'

export const documentsListQueryOptions = (deps: Partial<DocumentListFilterParams>) =>
  queryOptions({
    queryKey: ['documentsList', deps],
    queryFn: () => Request.post(Request.urls.bank.documentList, { ...deps }),
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })
